import React from "react";
import { isEmail } from "@common/helpers/accounts";
import commonStyles from "@components/onboarding/steps/common.module.scss";
import classNames from "classnames";
import { noop } from "@common/helpers/function";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import {
    CodeVerification,
    CodeVerificationProps,
} from "@components/auth/CodeVerification/CodeVerification";
import { ResendCode } from "@components/auth/CodeVerification/ResendCode";
import { Button } from "@design-system/Button/Button";
import { LeftArrowIcon } from "@icons";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { PhoneNumberDisplay } from "../../phoneNumber/PhoneNumberDisplay";
import styles from "../Login.module.scss";

interface LoginFlowPhoneAuthProps {
    providedPhoneOrEmail: string;
    onBack(): void;
    onRequestCode: CodeVerificationProps["request"];
    onVerify: CodeVerificationProps["verify"];
}

export const LoginFlowCodeAuth: React.FC<LoginFlowPhoneAuthProps> = ({
    providedPhoneOrEmail,
    onBack,
    onVerify,
    onRequestCode,
}) => {
    const codeSentTo = isEmail(providedPhoneOrEmail) ? (
        providedPhoneOrEmail
    ) : (
        <PhoneNumberDisplay phoneNumber={providedPhoneOrEmail} />
    );

    return (
        <>
            <h1 className={classNames(styles.heading, commonStyles.title)}>
                Check your {isEmail(providedPhoneOrEmail) ? "email" : "phone"}
            </h1>
            <VStack gap={40}>
                <div className={styles.heading}>
                    We just sent a 6-digit code to {codeSentTo}
                    <br />
                    Proceed by typing your code below.
                </div>

                <CodeVerification
                    phoneOrEmail={providedPhoneOrEmail}
                    verify={onVerify}
                    request={onRequestCode}
                    requestOnMount={false}
                    onSuccess={noop}
                    lead={null}
                    resend={null}
                    renderSubmit={({ isValid, isSubmitting }) => (
                        <VStack gap={40}>
                            <HStack as="section" justify="center">
                                <ResendCode request={onRequestCode} />
                            </HStack>

                            <HStack as="footer" justify="center" gap={12}>
                                <Button
                                    variant="primary"
                                    onClick={onBack}
                                    size="xl"
                                    iconOnly
                                    aria-label="Go back"
                                >
                                    <LeftArrowIcon />
                                </Button>

                                <ButtonWithLoader
                                    disabled={!isValid}
                                    loading={isSubmitting}
                                    type="submit"
                                    size="xl"
                                    variant="primary"
                                >
                                    Verify
                                </ButtonWithLoader>
                            </HStack>
                        </VStack>
                    )}
                />
            </VStack>
        </>
    );
};
